import { HTMLAttributes, memo } from "react";
import classNames from "classnames";
import { Tooltip } from "../../Tooltip";
import { useGetMaintenancePeriod } from "../utils";

import { ReactComponent as WarningIcon } from "./icons/alert-triangle.svg";

import styles from "./styles.module.scss";

export type MaintenanceButtonProps = Omit<HTMLAttributes<HTMLDivElement>, "children">

export const MaintenanceButton = memo<MaintenanceButtonProps>((
  {
    className,
    ...props
  },
) => {
  return (
    <Tooltip
      content={"Scheduled Maintenance Notice"}
      supportingContent={
        <div className={styles.text}>
          Please be advised:
          <br />
          Our system will undergo scheduled maintenance on:
          <br />
          <br />
          🗓️ {useGetMaintenancePeriod()}
          <br />
          <br />
          During this time, the portal will be temporarily unavailable.
          This maintenance is essential to ensure continued performance and security improvements.
          <br />
          <br />
          We apologize for any inconvenience and appreciate your patience.
          If you have any questions, please contact us at support@tecorien.com.
        </div>
      }
    >
      <div
        {...props}
        className={classNames(styles.root, className)}
      >
        <WarningIcon />
      </div>
    </Tooltip>
  );
});